// ═══════════════════════════════════════════════════════════════════
//  useFromSearch — Reads history.state.fromSearch into a typed shape.
// ═══════════════════════════════════════════════════════════════════
//
//  When a user clicks a hit on /search, the SearchCanvas pushes
//  history with state.fromSearch = { hitId, query?, scope? }. Pages
//  rendered after that navigation can call this hook to:
//    - know they were opened from search
//    - render a "← Back to search results" breadcrumb
//
// ═══════════════════════════════════════════════════════════════════

import { useLocation } from 'react-router-dom';
import type { SearchScope } from '@/types/search';

export interface FromSearchState {
  hitId?: string;
  query?: string;
  scope?: SearchScope;
}

/** Returns the parsed `fromSearch` history state, or null. */
export function useFromSearch(): FromSearchState | null {
  const { state } = useLocation();
  if (!state || typeof state !== 'object') return null;
  const fs = (state as { fromSearch?: FromSearchState }).fromSearch;
  if (!fs || typeof fs !== 'object') return null;
  return {
    hitId: typeof fs.hitId === 'string' ? fs.hitId : undefined,
    query: typeof fs.query === 'string' ? fs.query : undefined,
    scope: fs.scope,
  };
}
